export default __webpack_public_path__ + "static/media/Gunderland Belt.34eca012.jpg";